import { render } from "./DollarAmount.vue?vue&type=template&id=5eb6e6d5"
import script from "./DollarAmount.vue?vue&type=script&lang=js"
export * from "./DollarAmount.vue?vue&type=script&lang=js"
script.render = render

export default script